import InfoPill from './InfoPill'

export default InfoPill
